export default "__VITE_ASSET__BHcmj0$l__"